import React from "react"
import Link from "gatsby-link"
import ReactSlick from 'react-slick'
import Parra from "../components/parra1"
import styled from "styled-components"
import { above, below, maxHeight } from "../style/functions"
import * as vars from "../style/vars"
import { Accordion, AccordionContainer } from '../components/accordion'
import RegisterForm from '../components/downForm'
import RegisterFloorplanForm from '../components/downFormFloorplan'
// import 'slick-carousel/slick/slick.css' import
// 'slick-carousel/slick/slick-theme.css'

import Video from "../components/video"
import Header from "../components/headerMobileNav.js"
import TextBlock from "../components/content_block"
import NewsCard from "../components/news_card"
import PhotoProduct from "../components/photo_product"
import { RichText, Date } from "prismic-reactjs"

import NextArrowImg from '../../static/svg/arrow-right-white.svg'
import PrevArrowImg from '../../static/svg/arrow-right-white.svg'
import StickyEnquire from "../components/sticky-enquire";


import { NextArrow, PrevArrow } from '../components/arrows'

let settings = {
   dots: true,
   autoplay: true,
   fade: true,
   infinite: true,
   autoplaySpeed: 4750,
   pauseOnHover: false,
   slidesToShow: 1,
   slidesToScroll: 1,
   waitForAnimate: false,
   nextArrow: <NextArrow />,
   prevArrow: <PrevArrow />
}

class productPage extends React.Component {
   // state = {
   //    location: null
   // }

   scrollFloorplan(e) {
      if (typeof window !== `undefined`) {
         window.scrollTo({
            top: 0,
            behavior: "smooth"
         })
      }
   }

   componentDidMount() {
      // const location = this.props.location.pathname
      const data = this.props.data.prismicProduct.data
      this
         .props
         .updateMeta(data.meta_title.text, data.meta_description)

         this.props.updateSlug(this.props.data.prismicProduct.uid);
         this.props.updatePageType(this.props.data.prismicProduct.type);
         this.props.togglePopup(false);
         this.props.updateFooterVisible(true);
         if(data.hide_footer === true){
            this.props.updateProductHide(true);
         }else{
            this.props.updateProductHide(false);
         }


   }

   render() {

      let data = this.props.data.prismicProduct.dataString
      data = JSON.parse(this.props.data.prismicProduct.dataString)
      let dataset = this.props.data.prismicProduct.data

      const element = this.props.data.prismicProduct

      const allSlides = []

      // console.log(data);

      // var offering_small_text = null;
      // try {
      //    offering_small_text = data.offering_small_text[0].text;
      // } catch (error) {
      //    offering_small_text = null;
      // };


      // var availability_small_text = null;
      // try {
      //    availability_small_text = data.availability_small_text[0].text;
      // } catch (error) {
      //    availability_small_text = null;
      // };


      data.slider.map(function (slide) {
         const img = []
         const img_mobile = []
         const img_dimensions = { "width": 2000, "height": 1250 }
         const img_alt = null
         const img_copyright = null
         const img_url = slide.slide.url;

         const mobile_dimensions = { "width": 750, "height": 582 }


         const logo = {}
         const image_anchor = "Center"
         const header = null
         const subheader = null
         const text = null
         const link = null

         img_mobile.push({ mobile_dimensions: mobile_dimensions, alt: img_alt, copyright: img_copyright, url: img_url })
         img.push({ dimensions: img_dimensions, alt: img_alt, copyright: img_copyright, url: img_url, mobile: img_mobile })


         allSlides.push({ img: img, logo: logo, image_anchor: image_anchor, header: header, subheader: subheader, text: text, link: link });
         // allSlides.push({
         //    "img": {
         //       "dimensions": {
         //          "width": 2000,
         //          "height": 1250
         //       },
         //       "alt": null,
         //       "copyright": null,
         //       "url": "/images/feb-19-updates/artisan/mid-slide-03.jpg",
         //    },
         //    "logo": {},
         //    "image_anchor": "Center",
         //    "header": null,
         //    "subheader": null,
         //    "text": null,
         //    "link": null
         // });
         //console.log(allSlides);
      })
      const download_title = dataset.project_section_title.text.replace(/.\s*$/, "") + " Download";
      const download_brochure = element.uid + "-brochure";
      const property = this.props.data.prismicProduct.uid;
      //console.log('property',property);

      var i = 0
      // const location = this.state.location || ''
      // const download_floorplan_title = dataset.project_section_title.text.replace(/.\s*$/, "") + " Download";
      // const download_floorplan = element.uid + "-floorplan";


      //console.log(dataset);
      //console.log(data);

      const current_utm = this.props.utm;
		//console.log(this.props);
      return (
         <div>
            <Header togglePopup={this.props.togglePopup} theme="trans" menu={this.props.data.prismicMainNavigation.data} />
            <StickyEnquire property={this.props.data.prismicProduct.uid} togglePopupState={this.props.popupVisible} togglePopup={this.props.togglePopup} utm={this.props.utm} updateFormDetails={(first_name,last_name,phone,email,property) => this.props.updateFormDetails(first_name,last_name,phone,email,property)}/>

            <SlideshowWrapper>
               <Overlay className="grid">
                  <div className="inner">
                     <img src={data.project_logo.url} />
                  </div>
               </Overlay>
               <ReactSlick {...settings}>
                  <SlideImgWrapper>
                     <div className="img">
                        {data.youtube__optional_.url
                           ? <Video url={data.youtube__optional_.url} poster={data.project_feature_image.url} popup />
                           : <img src={data.project_feature_image.url} />
                        }
                     </div>
                  </SlideImgWrapper>

               </ReactSlick>
            </SlideshowWrapper>
            <ProjectContent>
               <div className="grid ">
                  <div className="inner inner_wrapper">
                     <MainCopy className="col col-xs-12 col-06 ">
                        <h2>
                           {
                              dataset.project_section_title.text.split('\n')
                                 .map(function (item, key) {
                                    return (
                                       <span key={key}>
                                          {item}
                                          <br />
                                       </span>
                                    )
                                 })
                           }
                        </h2>
                        <div dangerouslySetInnerHTML={{ __html: dataset.project_section_description.html }} />

                     </MainCopy>
                     <MainTextOther isHero={true} className="col col-xs-12 col-04 primary_wrapper">
                        <div className="section__wrap">


                           {/* <h5>{data.offering[0].text}</h5> */}
                           <h4>{data.offering_text[0] &&
                              data.offering_text[0].text.split('\n')
                                 .map(function (item, key) {
                                    return (
                                       <span key={key}>
                                          {item}
                                          <br />
                                       </span>
                                    )
                                 })
                           }</h4>
                           <small>
                              {
                                 dataset.offering_small_text.text && dataset.offering_small_text.text !== null && dataset.offering_small_text.text !== ''
                                    ? dataset.offering_small_text.text.split('\n')
                                       .map(function (item, key) {
                                          return (
                                             <span key={key}>
                                                {item}
                                                <br />
                                             </span>
                                          )
                                       })
                                    : ""
                              }


                           </small>
                        </div>
                        <div className="section__wrap">
                           {/* <h5>{data.availability[0].text}</h5> */}
                           <h4>
                              {data.availability_text[0] &&
                                 data.availability_text[0].text.split('\n')
                                    .map(function (item, key) {
                                       return (
                                          <span key={key}>
                                             {item}
                                             <br />
                                          </span>
                                       )
                                    })

                              }
                           </h4>
                           <small>

                              {
                                 dataset.availability_small_text && dataset.availability_small_text.text && dataset.availability_small_text.text !== null && dataset.availability_small_text.text !== ''
                                    ? dataset.availability_small_text.text.split('\n')
                                       .map(function (item, key) {
                                          return (
                                             <span key={key}>
                                                {item}
                                                <br />
                                             </span>
                                          )
                                       })
                                    : ""
                              }



                           </small>
                        </div>

                        {/* {data.button_link.length > 0 ?

                           <Link className="btn btn-square white" to={{
                              pathname: data.button_link[0].text,
                              state: { fromProp: dataset.project_section_title.text.replace(/(\r\n|\n|\r)/gm, " ") }
                           }} >
                              <span>
                                 {data.button_text[0].text}
                              </span>
                           </Link>

                           :
                           ''
                        } */}

<div className="button_wrapper">
                        {
                           data.body.map(function (slice) {
                              i++
                              switch (slice.slice_type) {

                                 case 'text_with_floorplan_download':
                                    return (
                                       <button onClick={() => {

                                          function getElementOffset(el) {
                                             let top = 0;
                                             let left = 0;
                                             let element = el;

                                             // Loop through the DOM tree
                                             // and add it's parent's offset to get page offset
                                             do {
                                               top += element.offsetTop || 0;
                                               left += element.offsetLeft || 0;
                                               element = element.offsetParent;
                                             } while (element);

                                             return {
                                               top,
                                               left,
                                             };
                                           }

                                          const floorPlan = document.getElementById("view-floorplan");
                                          const floorPlanLocation = getElementOffset(floorPlan)
                                          const header = document.getElementsByTagName("header")[0];
                                          const headerHeight = header.offsetHeight;
                                          const scrollOffset = floorPlanLocation.top - headerHeight - 50;

                                          window.scrollTo({
                                             top: scrollOffset,
                                             behavior: "smooth"
                                          })
                                        }} className="btn btn-square white"><span>View Floorplan</span></button>
                                    )
                              }
                           })
                        }


                        {data.button_link.length > 0 && data.button_link[0].text !== ''
                        ?
                           [
                              //if internal check
                              /^\/(?!\/)/.test(data.button_link[0].text) === true
                              ?
                              <Link className="btn btn-square white" to={{pathname: data.button_link[0].text, state:{property:property } }} ><span>{data.button_text[0].text}</span></Link>
                              :
                              <a href={data.button_link[0].text} className="btn btn-square white" target="_blank"><span>{data.button_text[0].text}</span></a>
                           ]
                        :
                           ''
                        }


                        {data.button_2_link.length > 0 && data.button_2_link[0].text !== ''
                        ?
                           [
                              //if internal check
                              /^\/(?!\/)/.test(data.button_2_link[0].text) === true
                              ?
                              <Link className="btn btn-square white" to={{pathname: data.button_2_link[0].text, state:{ property:property } }}><span>{data.button_2_text[0].text}</span></Link>
                              :
                              <a href={data.button_2_link[0].text} className="btn btn-square white" target="_blank"><span>{data.button_2_text[0].text}</span></a>
                           ]
                        :
                           ''
                        }

                        {data.button_3_link.length > 0 && data.button_3_link[0].text !== ''
                        ?
                           [
                              //if internal check
                              /^\/(?!\/)/.test(data.button_3_link[0].text) === true
                              ?
                              <Link className="btn btn-square white" to={{pathname: data.button_3_link[0].text, state:{ property:property } }}><span>{data.button_3_text[0].text}</span></Link>
                              :
                              <a href={data.button_3_link[0].text} className="btn btn-square white" target="_blank"><span>{data.button_3_text[0].text}</span></a>
                           ]
                        :
                           ''
                        }
</div>
                     </MainTextOther>
                  </div>
               </div>


               <PhotoProduct
                  mini={true}
                  slides={allSlides}
                  fixText={false}
                  hero={false}
                  autoplay={true}
               />


            </ProjectContent>

            {
               data.body.map(function (slice) {
                  i++
                  //console.log(slice);
                  switch (slice.slice_type) {

                     case 'carousel':
                        //console.log(slice);

                        const carouselSlides = []
                        slice.items.map(function (slide) {
                           const img = []
                           const img_mobile = []
                           const img_dimensions = { "width": 2000, "height": 1250 }
                           const img_alt = null
                           const img_copyright = null
                           const img_url = slide.image.url;

                           const mobile_dimensions = { "width": 750, "height": 582 }


                           const logo = {}
                           const image_anchor = "Center"
                           const header = slide.title
                           const subheader = slide.subtitle
                           const text = null
                           const link = null

                           img_mobile.push({ mobile_dimensions: mobile_dimensions, alt: img_alt, copyright: img_copyright, url: img_url })
                           img.push({ dimensions: img_dimensions, alt: img_alt, copyright: img_copyright, url: img_url, mobile: img_mobile })


                           carouselSlides.push({ img: img, logo: logo, image_anchor: image_anchor, header: header, subheader: subheader, text: text, link: link });
                        })

                        return (

                              <PhotoProduct
                                 mini={true}
                                 slides={carouselSlides}
                                 fixText={false}
                                 hero={false}
                                 dots={false}
                                 autoplay={true}
                              />

                        )

                     case 'single_image_block':
                        //console.log(slice);
                        return (
                           <div className="grid">
                              <div className="inner">
                                 <img
                                    style={{
                                       marginBottom: '3rem',
                                       width: '100%'
                                    }}
                                    src={slice.primary.image.url} />
                              </div>
                           </div>
                        )

                     case 'accordian':

                        return (
                           <div>
                              <div className="grid">
                                 <div className="inner" style={{
                                    marginBottom: '-7rem',
                                    marginTop: '6rem'
                                 }}>
                                    <div>
                                       <h3>

                                          {
                                             slice.primary.title[0].text && slice.primary.title[0].text !== null && slice.primary.title[0].text !== ''
                                                ? slice.primary.title[0].text.split('\n')
                                                   .map(function (item, key) {
                                                      return (
                                                         <span key={key}>
                                                            {item}
                                                            <br />
                                                         </span>
                                                      )
                                                   })
                                                : ""
                                          }



                                          {/* {slice.primary.title[0].text} */}
                                       </h3>
                                    </div>
                                 </div>
                              </div>
                              <AccordionContainer>
                                 <div className="grid" >
                                    <div className="inner" >
                                       {slice.items.map((i, idx) => {
                                          return (
                                             <Accordion
                                                title=""
                                                bath={i.bathroom}
                                                bed={i.bedroom}
                                                car={i.carpark}
                                                study={i.study}
                                                name=""
                                                logo=""
                                                image={i.image.url}
                                                dir="right"
                                                cta={{ link: '', text: 'Read more' }}
                                                html={RichText.render(i.html)}
                                             />
                                          )
                                       })}
                                    </div>
                                 </div>
                              </AccordionContainer>
                           </div>
                        )

                     case 'text_with_floorplan_download':
                        //console.log(slice);
                        return (

                           <Container >
                              <div className="grid ">
                                 <div className="inner">
                                    <MainCopy className="col col-xs-12 col-06 black ">
                                       <h1>{slice.primary.title[0].text}

                                       </h1>
                                       <p className="ct__arrow">


                                          {slice.primary.subtitle[0].text.split('\n').map(function (item, key) {
                                             return (
                                                <span key={key}>
                                                   {item}
                                                   <br />
                                                </span>
                                             )
                                          })}

                                       </p>
                                    </MainCopy>

                                    <MainTextOther className="col col-xs-12 col-06 black" id="view-floorplan">
                                       <h1>{slice.primary.form_title[0].text}</h1>
                                       <RegisterFloorplanForm utm={current_utm} product={property} url={slice.primary.floorplan_url[0].text} />
                                    </MainTextOther>

                                 </div>
                              </div>
                           </Container>


                        )
                     case 'text_-_full_width':
                        //console.log(slice);
                        return (

                           <Container>
                              <div className="grid ">
                                 <div className="inner">
                                    <MainCopy className="col col-xs-12 col-12 black no-rhs-border ">
                                       <h1>{slice.primary.title[0].text}
                                       </h1>
                                       <p dangerouslySetInnerHTML={{ __html: slice.primary.subtitle[0].text.replace(/\n/g, '<br>') }}>

                                       </p>
                                    </MainCopy>
                                 </div>
                              </div>
                           </Container>


                        )
                     case 'text_with_brochure_download':
                        //console.log(slice);
                        return (

                           <Container>
                              <div className="grid ">
                                 <div className="inner">
                                    <MainCopy className="col col-xs-12 col-06 black ">
                                       <h1>{slice.primary.title[0].text}

                                       </h1>
                                       <p>


                                          {slice.primary.subtitle[0].text.split('\n\n').map(function (item, key) {
                                             return (
                                                <span key={key}>
                                                   {item}
                                                   <br /><br />
                                                </span>
                                             )
                                          })}

                                       </p>
                                    </MainCopy>

                                    <MainTextOther className="col col-xs-12 col-06 black">
                                       <h1>{slice.primary.form_title[0].text}</h1>
                                       <RegisterForm utm={current_utm} product={property} tags={download_title} brochure={download_brochure} brochure_full={slice.primary.form_brochure_pdf.url} />
                                    </MainTextOther>

                                 </div>
                              </div>
                           </Container>


                        )
                  }
               }
               )
            }



         </div >
      )
   }
}

export default productPage


const SlideshowWrapper = styled.div`

position: relative;

   .slick-track {
      background-color: #3f3e3e;
   }

   .slick-list, .slick-track {
      transform: none !important;
   }

   .arrow {
      position: absolute;
      display: block;
      height: 50px;
      width: 50px;
      z-index: 1;
      top: 60%;
      transform: translateY(-50%);
      margin: 0 2vw;
      cursor: pointer;
      ${below.tablet`
         display: none;
      `}
   }

   .next-arrow {
      right: 0;
      background-image: url(${NextArrowImg});
   }
   .prev-arrow {
      transform: rotate(180deg);
      transform-origin: 50% 24%;
      background-image: url(${PrevArrowImg});
   }

   .slick-dots {
      margin-left: 17rem;
      bottom: 9%;
      width: auto;
      list-style: none;
      text-align: center;
      li button {
         background: transparent;
         border: 1px solid white;
         border-radius: 50%;
				 width:20px;
				 height:20px;
				 &:before, &:after{
					width:20px;
				 height:20px;
				 }
         :hover:before {
            background: white;
            opacity: 1;
         }
         :before {
            content: '';
            background-color: white;
            border-radius: 50%;
            opacity: 0;
            transition: opacity .5s;
         }
      }

      ${below.tablet`
         margin: 0;
         left: 50%;
         bottom: 3%;
         transform: translateX(-50%);
      `}
   }
`
const SlideImgWrapper = styled.div`
   height: 100vh;
	 ${below.mobile`
			height: 50vh;
			`}
   img {
      width: 100%;
      height: 100vh;
      object-fit: cover;
			${below.mobile`
			height: 50vh;
			`}

   }
	 .img{
		 position: relative;
		 &:before{
			 content: '';
			 position: absolute;
			 top: 0;
			 right: 0;
			 bottom: 0;
			 left: 0;
			 background: linear-gradient(to bottom, rgba(63, 62, 62, 0.4) 0%, rgba(63, 62, 62, 0.2) 20%,rgba(0,0,0,0) 100%);
		 }
	 }
`

const Overlay = styled.div`
	position: absolute;
	bottom: 10%;
	left: 0;
	right: 0;
	z-index: 10;
	${below.mobile`
		img{
			max-width: 200px;
		}
	`}
`

const ProjectContent = styled.div`
   border-top: 1px solid;
	 border-bottom: none;

   background-image: linear-gradient(${vars.colors.body} 60%, white 30%);
   ${above.desktop`
   .inner_wrapper{
display:flex
   }
   `}

   .grid {
      margin: 7rem auto;
			${below.mobile`
				margin-top: 2rem;
			`}
   }
`

const MainCopy = styled.div`
   padding-bottom: ${vars.padding.inner}rem;
   padding-right: ${vars.padding.inner}rem;
   border-left: ${props => props.isHero
      ? '1'
      : '1'}px solid #fff;
	 padding-left: 3.5rem;
   border-right: ${props => props.isHero
      ? '1'
      : '1'}px solid #fff;
	 color: #fff;

	 ${below.tablet`
		border: none;
		padding-left: 0;
		padding-bottom: 25px;
	 `}
	 div{
		 border-color: #fff;
	 }
	img{
		width: 200px;
	}
	&.black {
		border-color: #3f3e3e;
		color: #3f3e3e;
		div{
			border-color: #3f3e3e;
		}
      &.no-rhs-border{
         border-right:none!important;
         padding-bottom:0!important;
         p{
            padding-bottom: 0!important;
         }
      }
	}
   ${below.tablet`
      padding-bottom: 0;
      border-right: none;
   `};

`
const MainTextOther = styled.div`
   padding-left: ${vars.padding.inner}rem;
 color: #fff;

 &.primary_wrapper{
    padding-top:22px;
 }


   ${below.tablet`
      border-left: none;
      padding-left: 0;
   `};

   h4 {
      padding-bottom: 3rem;
      padding-bottom:0;
   }
   h5 {
      font-size: ${vars.padding.inner / 2}rem;
      padding-bottom: ${vars.padding.inner / 5}rem;

   }
   small {
      display: block;
      padding-top: 0.5rem;
  }

  .button_wrapper{
   padding-top: 22px;

   display: flex;
   flex-direction: column;
   align-items: flex-start;

   .btn{
      margin-bottom: 12px;
      &:last-child{
         margin-bottom:0;
      }
   }
  }

   .section__wrap{
      padding-bottom: .58rem;
   }
	 &.black {
		border-color: #3f3e3e;
		color: #3f3e3e;
		/* div{
			border-color: #3f3e3e;
		} */
	}
`

const Container = styled.div`
   padding: 0;
   position: relative;
   margin-bottom: ${vars.padding.inner * 2}rem;

   h1 {
      letter-spacing: .03rem;
      font-family: ${vars.fonts.feature};
      font-weight: normal;
      font-size:5.7rem;
      padding-bottom: ${vars.padding.inner / 2}rem;
      line-height:1;
      padding-right: 40px;
      ${below.tablet`
         padding-right: 0;
         font-size:4rem;
      `}
      ${below.mobile`
         font-size:2.6rem;
      `}
   }

   .form__thankyou  a:not(.link-email):after {
      content: url(/svg/arrow-dark.svg);
   }
   h2 {
		font-family: ${vars.fonts.main};
		font-size:2.3rem;
		font-weight: normal;
		${below.tablet`
			font-size:2.3rem;
		`}
		${below.mobile`
			font-size:2rem;
		`}
      padding-bottom: ${vars.padding.mobInner}rem;
   }

   .grid .col {
      min-height: 20rem;
      ${below.tablet`
         min-height: 0;
         padding-left: none;
         border-left: none;
      `}
   }

   .grid .col:first-of-type {
      border-left: 1px solid ${vars.colors.body};
      padding-left: ${vars.padding.inner}rem;
      ${below.tablet`
         padding-left:0;
				 border-left: none;
				 padding-bottom: 25px;
      `}
   }

   .border-left {
      border-left: 1px solid ${vars.colors.body};
      padding-left: ${vars.padding.inner}rem;
   }

   .mob-border-left {
      border-left-width: 0;
      padding-left: ${vars.padding.inner}rem;

      ${below.tablet`
         border-left-width: 0.2rem;
      `}
   }

   &.invert-color {
      background: ${vars.colors.body};
      color: ${vars.colors.blank};
      margin-top: 6rem;

      .grid .inner div {
         border-color: ${vars.colors.blank};
      }
   }
`

export const pageQuery = graphql`
   query productPage($id: String) {
      prismicProduct(id: { eq: $id }) {
         id
         uid
         type
         dataString
         data {
            meta_title {
               html
               text
            }
            meta_description
            project_section_title{
               html
               text
            }
            project_section_description{
               html
               text
            }
            # availability_small_text{
               # html
               # text
            # }
            offering_small_text{
               html
               text
            }
            hide_footer

         }
      }
      prismicMainNavigation {
         id
         dataString
         data {
           display_name {
             html
             text
           }
           nav {
             slice_type
             primary {
               label {
                 text
               }
               link {
                 text
               }
             }
             items {
               sub_nav_link_label {
                 text
               }
               sub_nav_link {
                 text
               }
             }
           }
         }
       }
   }
`



// WEBPACK FOOTER //
// ./src/templates/product.js